import { version } from "./config";
import { http_get, http_post } from "./helpers";

export type Simulation = {
    createUserName: string;
    createNickName: string;
    title: string;
    logo: string;
    beginTime: string;
    endTime: string;
    typeId: number;
    description: string;
    status: number;
    major: string;
    grade: string;
    creationTime: string;
    createUserId: number;
    designFinishStatus: number;
    step: number;
    id: number;
};
export type SimulationDetail = {
    viewSettings: string;
    title: string;
    designTaskId: number;
    sort: number;
    designFileId: number;
    classType: number;
    creationTime: string;
    createUserId: number;
    id: number;
};
export type DesignFile = {
    name: string;
    classType: number;
    typeId: number;
    uploadFileId?: number;
    isFinish?: boolean;
    viewFileId?: number;
    creationTime?: string;
    createUserId?: number;
    id?: number;
};
export type UploadFile = {
    fileId: string;
    fileName: string;
    fileExtention: string;
    fileConvertState: number;
    fileSize: number;
    fileUrl: string;
    creationTime?: string;
    createUserId?: number;
    id?: number;
};
export type ViewFile = UploadFile;
export type DesignFileView = {
    viewSettings: string;
    designFileId: number;
    title?: string;
    creationTime?: string;
    createUserId?: number;
    id?: number;
};
type GetSimulationListParams = {
    classType?: number;
    typeId?: number;
    status?: number;
    filter?: string;
    major?: string;
    grade?: string;
    sorting?: "0" | "1";
    skipCount: number;
    maxResultCount: number;
};
type GetSimulationListResponse = {
    totalCount: number;
    items: Simulation[];
};

type GetSimulationDetailParams = {
    designTaskId: number;
};
type GetSimulationDetailResponse = SimulationDetail[];

type ChangeLearningStatusParams = {
    designTaskId: number;
    targetId: number;
    status: number;
    step: number;
};
type ChangeLearningStatusResponse = {};

type GetSimulationResrouceDetailParams = {
    designFileId: number;
};
type GetSimulationResrouceDetailResponse = {
    designFile: DesignFile;
    uploadFile: UploadFile;
    viewFile: ViewFile;
    designFileViewList: DesignFileView[];
};
/**
 * 获取仿真列表
 */
export const getSimulationList = http_post<GetSimulationListParams, GetSimulationListResponse>(
    `/api/v${version}/m/MyStuding/QueryMyDesignTasks`
);

/**
 * 获取仿真详情
 */
export const getSimulationDetail = http_post<
    GetSimulationDetailParams,
    GetSimulationDetailResponse
>(`/api/v${version}/m/MyStuding/{designTaskId}/DesignTask_Views`);

/**
 * 更改学习状态
 */
export const changeLearningStatus = http_post<
    ChangeLearningStatusParams,
    ChangeLearningStatusResponse
>(`/api/v${version}/m/MyStuding/{designTaskId}/DesignTask_UpdateDesignFinishStatus`);

/**
 * 更改学习状态
 */
export const getSimulationResrouceDetail = http_post<
    GetSimulationResrouceDetailParams,
    GetSimulationResrouceDetailResponse
>(`/api/v${version}/m/MyStuding/{designFileId}/DesignFile_Details`);

/**
 * 获取枚举
 */
export const getEnums = http_get<
    {
        group: string;
    },
    {
        val: string;
        txt: string;
    }[]
>(`/api/v${version}/f/Enums`);

/**
 * 获取题目
 */
export const getQuestionById = http_post<
    {ids: number[] | string[]},
    any
>(`/api/v${version}/m/MyStuding/QueryMyDesignQuestionsListByIds`);
